// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 854 ? "widgets" : chunkId) + "." + {"63":"1606d492","444":"84a4dede","854":"aea31e17"}[chunkId] + ".js";
};